import React, { memo } from 'react';

import { areEqual } from 'Utils/equalityChecks';
import { Modal } from 'Components/Modal';
import { PurpleButton } from 'Components/Button';
import { EquipmentAsset } from 'Containers/SerializedEquipment/types';

import classes from './retireAssetModal.module.css';

interface Props {
  isOpen: boolean;
  asset: EquipmentAsset | null;
  submitting: boolean;
  submitError: string | null;
  onConfirm: (e: any) => void;
  onClose: (e: any) => void;
}

// Confirm retiring (soft-deleting) a serialized unit. Retire is only offered for units that are not
// deployed/retired, so the backend's "check out first" 422 should be rare; surfaced if it happens.
function RetireAssetModal({ isOpen, asset, submitting, submitError, onConfirm, onClose }: Props) {
  return (
    <Modal
      id="retire-asset-modal"
      classes={classes}
      title="Retire Equipment"
      isOpen={isOpen}
      modalHeader
      dataBsBackdrop="static"
      dataBsKeyboard="false"
      modalCloseClick={onClose}
    >
      <div className="d-flex flex-column w-100" data-testid="retire-asset-modal">
        <p className={classes.body}>
          Retire
{' '}
<strong>{asset?.name ?? 'this unit'}</strong>
          {asset?.serial_number ? ` (${asset.serial_number})` : ''}
? It will no longer be available to
          deploy. This can’t be undone from here.
</p>

        {submitError && (
          <p className={classes.error} role="alert" data-testid="retire-error">
            {submitError}
          </p>
        )}

        <div className={`modal-footer ${classes.modalFooter}`}>
          <PurpleButton type="button" onClick={onClose} className={classes.cancelButton}>
            Cancel
          </PurpleButton>
          <PurpleButton type="button" onClick={onConfirm} disabled={submitting} useDeleteColor>
            Retire
          </PurpleButton>
        </div>
      </div>
    </Modal>
  );
}

const RetireAssetModalMemo = memo(RetireAssetModal, areEqual);

export { RetireAssetModalMemo as RetireAssetModal };
